import GroupPostComponent from "./GroupPostComponent";
export default GroupPostComponent;
